import { useTranslation } from "react-i18next";
import { RemoteErrorAlert } from "src/components/PageState/RemoteErrorAlert";

import type { BrandCollectionErrorState } from "./useGetAllBrand";

type BrandCollectionStateErrorProps = {
    state: BrandCollectionErrorState;
    onRetry: () => void | Promise<unknown>;
};

export const BrandCollectionStateError = (props: BrandCollectionStateErrorProps) => {
    const { state, onRetry } = props;
    const { t } = useTranslation();

    const message = (() => {
        switch (state.status) {
            case "contract-error":
                return t("brand.contract_error", "Brand data is incomplete. Please refresh and try again.");
            case "forbidden":
                return t("brand.error.forbidden", "You are forbidden from viewing Brand data.");
            case "not-found":
                return t("brand.error.not_found", "Brand data was not found.");
            case "server-error":
                return t("brand.error.server", "Brand data could not be loaded. Please try again.");
        }
    })();

    return <RemoteErrorAlert message={message} onRetry={onRetry} status={state.status} />;
};
